import { fetchMonthlyStatsAllUsers } from '../api/records';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useQuery } from "@tanstack/react-query";

// Generates evenly spaced HSL colors for any number of workers
const generateColors = (count) => {
        return Array.from({length: count}, (_, i) =>
        `hsl(${(i*360) / count}, 70%, 60%)`);
    };

// Sub-components
const CustomToolTip = ({ active, payload }) => {
        if (!active || !payload?.length) return null;
        return (
            <div className='bg-primary-800 border border-primary-50 rounded-lg p-2'>
                <p className='text-white text-sm'>{payload[0].name}</p>
                <p className='text-white text-sm font-bold'>${payload[0].value}</p>
            </div>
        );
        };

// Main component
const WorkerPieChart = () => {
    const {data: monthly_revenue = [], isLoading} = useQuery({
            queryKey: ['monthly-revenue-all-users'],
            queryFn: fetchMonthlyStatsAllUsers
    });
    const COLORS = generateColors(monthly_revenue.length);
    
    return (
        <div className='mb-4'>
            {/* Header */}
            <p className="text-primary-50 text-xs font-mono mb-1">WORKER DISTRIBUTION</p>
            <div className='bg-primary-800 rounded-2xl p-4'>
                {isLoading ? (
                    <div className='flex items-center justify-center h-[300px]'>
                        <p className='text-primary-50 text-xs font-mono'>Loading...</p>
                    </div>
                ) : (
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={monthly_revenue}
                            dataKey="total_amount"
                            nameKey="name"
                            innerRadius="70%"
                            outerRadius="90%"
                            cornerRadius={6}
                            paddingAngle={5}
                            stroke="none">
                                {monthly_revenue.map((_, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                            </Pie>
                        <Legend 
                        iconType='circle'
                        iconSize={8}
                        formatter={(value) => (
                            <span style={{color: '#9ca3af', fontSize: 11 }}>{value}</span>
                        )}/>
                        <Tooltip content={<CustomToolTip />}/>
                    </PieChart>
                </ResponsiveContainer>)}
            </div>
        </div>
    );
};
export default WorkerPieChart;